import Routes from 'Routes';
import { initloginInfo } from '../easyLogin/modules/actions';

export default store => ({
  path: Routes.ticket.child.easyLogin.key,
  onEnter(nextState, replace, callback) {
    if (!nextState.location.query.easyMoreQuery) {
      store.dispatch(initloginInfo());
    }
    callback();
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const easyLogin = require('./components/easyLogin').default;
        cb(null, easyLogin);
      },
      'easyLogin'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/easyLogin/index.js